<div class="inner-card d-flex flex-column gap-4" [class.current]="showAsCurrentState" [class.new]="showAsNewState">
  <div class="d-flex flex-column gap-1">
    <div class="payment-frequency-header">
      <span *ngIf="isMonthly" i18n>Monthly Payments</span>
      <span *ngIf="!isMonthly" i18n>Annual Payments</span>
    </div>
    <div *ngIf="subtitle" class="subtitle">{{ subtitle }}</div>
  </div>

  <div class="d-flex flex-column gap-3">
    <ng-container *ngFor="let row of rows; let last = last">
      <div class="payment-row">
        <div class="d-flex align-items-center gap-2">
          <span class="paragraph-lg">{{ row.jurisdictionName }}</span>
          <span *ngIf="row.isNew" class="new-pill" i18n>New</span>
        </div>
        <div *ngIf="row.amount !== null" class="amount-cell">
          <div class="row-amount">
            <span>{{ row.amount | currency }}</span
            ><span *ngIf="isMonthly" i18n class="period"> /mo</span
            ><span *ngIf="!isMonthly" i18n class="period"> /yr</span>
          </div>
          <div class="payment-type-label">{{ row.paymentTypeLabel }}</div>
        </div>
      </div>
      <hr *ngIf="!last" class="m-0" />
    </ng-container>
    <hr class="m-0" />
  </div>

  <div class="total-container">
    <div class="estimated-total-row">
      <span i18n class="desktop-text">Estimated Recurring Payments Total:</span>
      <span i18n class="mobile-text">Est. Recurring Payments Total:</span>
      <div class="total-amount">
        <span>{{ total | currency }}</span
        ><span *ngIf="isMonthly" i18n class="period"> /mo</span><span *ngIf="!isMonthly" i18n class="period"> /yr</span>
      </div>
    </div>
    <div *ngIf="isMonthly" class="estimated-total-row">
      <span i18n class="annual-total-label">Est. Recurring Payments Annual Total</span>
      <div class="annual-total-value">
        <span>{{ annualTotal | currency }}</span>
        <span i18n> /yr</span>
      </div>
    </div>
  </div>
</div>
